import * as C from '../constants';
import giftVoucherTemplateService from '../../../services/gift-voucher-template-service';

export default {
  getDomains({ commit }) {
    commit(C.GIFT_VOUCHER_TEMPLATES_DOMAINS_PENDING);
    giftVoucherTemplateService.getDomains().then((res) => {
      if (res.status === 200) {
        commit(C.GIFT_VOUCHER_TEMPLATES_DOMAINS_SUCCESS, res.data);
      } else {
        commit(C.GIFT_VOUCHER_TEMPLATES_DOMAINS_FAILURE);
      }
    }).catch(() => {
      commit(C.GIFT_VOUCHER_TEMPLATES_DOMAINS_FAILURE);
    });
  },

  setDomain({ commit, dispatch }, domain) {
    commit(C.GIFT_VOUCHER_TEMPLATES_DOMAINS_SET, domain);
    dispatch('getGiftVoucherTemplates');
  },

  getGiftVoucherTemplates({ commit, state }) {
    commit(C.GIFT_VOUCHER_TEMPLATES_PENDING);
    giftVoucherTemplateService.getGiftVoucherTemplates(state.domain).then((res) => {
      if (res.status === 200) {
        commit(C.GIFT_VOUCHER_TEMPLATES_SUCCESS, res.data);
      } else {
        commit(C.GIFT_VOUCHER_TEMPLATES_NO_CONTENT);
      }
    }).catch(() => {
      commit(C.GIFT_VOUCHER_TEMPLATES_FAILURE);
    });
  },

  addGiftVoucherTemplate({ commit, dispatch, state }, template) {
    commit(C.GIFT_VOUCHER_TEMPLATES_SAVE_PENDING);
    return giftVoucherTemplateService.addGiftVoucherTemplate(state.domain, template).then(() => {
      commit(C.GIFT_VOUCHER_TEMPLATES_SAVE_SUCCESS);
      dispatch('getGiftVoucherTemplates');
    }).catch(() => {
      commit(C.GIFT_VOUCHER_TEMPLATES_SAVE_FAILURE);
      return Promise.reject();
    });
  },

  updateGiftVoucherTemplate({ commit, dispatch }, template) {
    commit(C.GIFT_VOUCHER_TEMPLATES_SAVE_PENDING);
    return giftVoucherTemplateService.updateGiftVoucherTemplate(template).then(() => {
      commit(C.GIFT_VOUCHER_TEMPLATES_SAVE_SUCCESS);
      dispatch('getGiftVoucherTemplates');
    }).catch(() => {
      commit(C.GIFT_VOUCHER_TEMPLATES_SAVE_FAILURE);
      return Promise.reject();
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucherTemplates/actions.js